<template>
  <div class="internal-bill-info">
    <cargo-up-down-resize
      class="section"
      :up-style="{display: 'flex', flexDirection: 'column', paddingBottom: '5px'}"
      :down-style="{display: 'flex', flexDirection: 'column', paddingTop: '5px'}"
      style="height: 100%"
    >
      <template slot="up">
        <div class="operations">
          <div class="triggers">
            <div style="display: flex;">

              <span v-show="controllerVisible.showSpecialCharge" style="color:#404144;margin-right: 5px">{{ this.$t('FinanceManage.domestic_billingBranchId') }}</span>
              <el-select
                v-show="controllerVisible.showSpecialCharge"
                v-model="specialBillingBranchId"
                :disabled="!readonly"
                :placeholder="$t('SeaExport.PleaseSelect')"
                :clearable="false"
                size="mini"
                style="margin-right: 5px"
                @change="p=>{ pm.onBillingBranchIdHandler(p)}"
              >
                <el-option
                  v-for="(item,index) in officeList"
                  :key="index"
                  :label="item.chineseName"
                  :value="item.officeId"
                />
              </el-select>
              <el-checkbox
                v-show="masterFlag"
                v-model="cbShowAllBilling"
                no="domestic_showAllBilling"
                style="margin-right: 5px"
                @change="pm.showAllBillingHandler()"
              >{{ this.$t('FinanceManage.domestic_showAllBilling') }}</el-checkbox>
              <el-checkbox
                v-show="controllerVisible.cbShowSelfChanges"
                v-model="cbShowSelfChanges"
                no="domestic_commissionedChargesOnly"
                style="margin-right: 5px"
                @change="pm.showSelfChangeHandler()"
              >{{ this.$t('FinanceManage.domestic_commissionedChargesOnly') }}</el-checkbox>
              <el-checkbox
                v-show="controllerVisible.cbShowInternal"
                v-model="cbShowInternal"
                no="domestic_showInternal"
                style="margin-right: 5px"
                @change="pm.showInternalChargeHandler()"
              >{{ this.$t('CargoMsg.Cargo_ShowInternalCharges') }}</el-checkbox>
            </div>
            <cargo-button-group-slider align="right" style="flex:1; border: none">
              <div>
                <!-- 指令操作按钮 -->
                <template v-for="(item, index) in instructioinBtns">
                  <el-button
                    :key="index"
                    :no="item.platformInstructionRuleCode"
                    type="primary"
                    :disabled="item.platformInstructionRuleCode === 'internalBillEdit' ? !item.allowOperate || !btnEnable.btnEdit : !item.allowOperate || job.jobState !== 0"
                    @click="onInstructionClick(item)"
                  >
                    {{ $selectByLang(item.chineseName, item.englishName, item.japaneseName) }}
                  </el-button>
                </template>
                <el-button v-if="!billPageSet.newReceiveHide" v-permission="['button_InternalBillInfo_accountAdd']" no="accountAdd" type="primary" :disabled="!btnEnable.btnAccountAdd" @click="pm.btnAddAccountClickHandler()">{{ this.$t('FinanceManage.domestic_newReceivables') }}</el-button>
                <el-button v-if="!billPageSet.newPayHide" v-permission="['button_InternalBillInfo_payAdd']" no="payAd" type="primary" :disabled="!btnEnable.btnPayAdd" @click="pm.btnAddPayClickHandler()">{{ this.$t('FinanceManage.domestic_newPayables') }}</el-button>
                <el-button v-if="!billPageSet.editHide" no="domestic_edit" type="primary" :disabled="!btnEnable.btnEdit" @click="pm.btnEditClickHandler()">{{ this.$t('FinanceManage.domestic_edit') }}</el-button>
                <el-button v-permission="['button_InternalBillInfo_delete', 'button_InternalBillInfo_deleteSelf']" no="delete" type="danger" :disabled="selectedDataList.length > 0 ? false : !btnEnable.btnDel" @click="pm.btnDelClickHandler()">{{ this.$t('FinanceManage.domestic_delete') }}</el-button>
                <el-button no="domestic_view" type="primary" :disabled="!btnEnable.btnView" @click="pm.btnViewClickHandler()">{{ this.$t('FinanceManage.domestic_view') }}</el-button>
                <!--作废-->
                <el-button v-show="btnEnable.btnInvalidShow" no="btnInvalid" type="primary" :disabled="!btnEnable.btnInvalidEnable" @click="pm.onInvaidClickEvent()">{{ $t('FinanceManage.international_invalid') }}</el-button>
                <el-button v-permission="['button_Billing_confirm']" no="confirm" type="primary" :disabled="selectedDataList.length > 0 ? false : !btnEnable.btnConfrim" @click="btnConfrimClickHandle">{{ this.$t('FinanceManage.domestic_confirm') }}</el-button>
                <el-button v-permission="['button_Billing_cancelConfrim']" no="cancelConfrim" type="primary" :disabled="selectedDataList.length > 0 ? false : !btnEnable.btnCancelConfrim" @click="pm.btnCancelConfrimHandler()">{{ this.$t('FinanceManage.domestic_cancelConfirm') }}</el-button>
                <!--复核-->
                <el-tooltip type="primary" :content="$t('Billing.billing_recheckTip')" placement="bottom">
                  <el-button v-permission="['button_InternalBillInfo_recheck']" style="margin-left: 5px;" no="recheck" type="primary" :disabled="!btnEnable.btnRecheck" @click="btnRecheckClickHandle">{{ this.$t('Billing.billing_recheck') }}</el-button>
                </el-tooltip>
                <!--取消复核-->
                <el-button v-permission="['button_InternalBillInfo_cancelRecheck']" no="cancelRecheck" type="primary" :disabled="!btnEnable.btnCancelRecheck" @click="pm.btnCancelRecheckBillingHandler()">{{ this.$t('Billing.billing_cancelRecheck') }}</el-button>
                <el-button v-permission="['button_InternalBillInfo_payauthFromBilling']" no="payauthFromBilling" type="primary" :disabled="!btnEnable.payauthFromBilling" @click="applyForPayment">{{ $t('Billing.billing_applyForPayment') }}</el-button>
              </div>
            </cargo-button-group-slider>
          </div>
        </div>
        <cargo-ag-grid
          no="130124"
          config-module="130124"
          :grid-options="up.gridOptions"
          :grid-params.sync="up.gridParams"
          :column-defs="upColumnDefs"
          :row-data="billingList"
          style="flex:1;margin-top:10px;"
          @gridReady="params=>up.gridApi=params.api"
        />
      </template>
      <template
        slot="down"
      >
        <cargo-ag-grid
          no="130125"
          config-module="130125"
          :grid-options="down.gridOptions"
          :grid-params.sync="down.gridParams"
          :column-defs="downColumnDefs"
          :row-data="chargeList"
          style="flex:1;margin:10px 0px;"
          @gridReady="params=>down.gridApi=params.api"
        />
      </template>
    </cargo-up-down-resize>
    <!-- 选择结算对象弹窗 -->
    <settlement-select-dialog :visible.sync="settlementSelectDialog.visible" :title="settlementSelectDialog.title" :accounts="settlementSelectDialog.accounts" :settlements="settlementSelectDialog.settlements" :source="'internalBillInfo'" @selectItemWinHandler="selectItemWinHandler" />
    <!--账单详情-->
    <bill-dialog
      v-if="billDialog.visible"
      ref="billDialog"
      :visible.sync="billDialog.visible"
      :billing-uuid="billDialog.billingUuid"
      :is-view="billDialog.isView"
      :new-billing="billDialog.newBilling"
      :new-charges="billDialog.newCharges"
      :department-team-user="billDialog.departmentTeamUser"
      :current-billing-branch-id="billDialog.currentBillingBranchId"
      :create-bill-way="billDialog.createBillWay"
      :accounts="billDialog.accounts"
      :job="job"
      :slave-charges="billDialog.slaveCharges"
      :location="location"
      :show-wht-tax="showWhtTax"
      :instruction-btns="billDialog.instructionBtns"
      @applyInvoice="bill=>{toMakeInvoiceWithBpm(bill,()=>{billDialog.visible=false})}"
      @viewInvoice="invoiceUuids=>{billDialog.visible=false; openInvoiceDetails(invoiceUuids)}"
      @reloadBillHandler="reloadBillHandler"
    />

    <!--拆分账单详情 参数用原来的 仅控制visible-->
    <split-bill-dialog
      v-if="newBillDialog.visible"
      ref="billDialog"
      :visible.sync="newBillDialog.visible"
      :billing-uuid="billDialog.billingUuid"
      :is-view="billDialog.isView"
      :new-billing="billDialog.newBilling"
      :new-charges="billDialog.newCharges"
      :department-team-user="billDialog.departmentTeamUser"
      :current-billing-branch-id="billDialog.currentBillingBranchId"
      :customer-detail="newBillDialog.customerDetail"
      :create-bill-way="billDialog.createBillWay"
      :accounts="billDialog.accounts"
      :job="job"
      :slave-charges="billDialog.slaveCharges"
      :location="location"
      :show-wht-tax="showWhtTax"
      :instruction-btns="billDialog.instructionBtns"
      @applyInvoice="bill=>{toMakeInvoice(bill,()=>{newBillDialog.visible=false})}"
      @viewInvoice="invoiceUuids=>{newBillDialog.visible=false; openInvoiceDetails(invoiceUuids)}"
      @reloadBillHandler="reloadBillHandler"
    />

    <!--账单详情-操作指令-->
    <operate-bill-dialog
      ref="operateBillDialog"
      :visible.sync="operateBillDialog.visible"
      :instruction-code="operateBillDialog.instructionCode"
      :location="location"
      :job="job"
      :need-tips="operateBillDialog.needTips"
      :show-wht-tax="showWhtTax"
      @reloadBillHandler="reloadBillHandler"
    />

    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      ref="templateDialog"
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="context"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />
    <!--申请付款-->
    <bill-payment-dialog
      ref="billPayment"
      :open-sap-config="false"
      :visible.sync="showBillPaymentDialog"
      :create-submit="true"
      :show-wht="showWhtTax"
      step="step2"
      source="append"
      :bill-payment-uuid="billPaymentDialogUuid"
      :job="job"
      :location="location"
      @cancel="cancel"
      @toPreStepForBusiness="p=>{this.showBillPaymentDialog=false;toPreStep()}"
    />
    <!-- 付款申请-H5（客户化版本）-->
    <new-bill-payment-dialog
      :visible="billPaymentDialogForH5.visible"
      :title="billPaymentDialogForH5.title"
      :bill-payment-account-id="billPaymentDialogForH5.defaultConditions.accountId"
      :view-source="billPaymentDialogForH5.source"
      :bill-payment-uuid="billPaymentDialogForH5.uuid"
      :default-conditions="billPaymentDialogForH5.defaultConditions"
      @close="billPaymentDialogForH5.visible=false"
    />
    <!--付款申请-H5（详情)-->
    <bill-payment-detail-for-h5
      v-if="billPaymentDialogForH5.billPaymentDetailProperties.visible"
      ref="billPaymentDetailForH5"
      :bill-payment-uuid="billPaymentDialogForH5.billPaymentDetailProperties.uuid"
      :title="billPaymentDialogForH5.billPaymentDetailProperties.title"
      :visible.sync="billPaymentDialogForH5.billPaymentDetailProperties.visible"
      :state="billPaymentDialogForH5.billPaymentDetailProperties.state"
      :charges="billPaymentDialogForH5.billPaymentDetailProperties.charges"
      :charges-dirty="true"
      :bill-payment-dirty="true"
      :open-sap-config="false"
      :input-by="billPaymentDialogForH5.billPaymentDetailProperties.inputBy"
      :parent-context="this"
      :location="location"
      view-source="tabBilling"
      @toPreStep="toPreStep"
      @refreshBillPayment="refreshBillPaymentH5"
    />
    <!--开票-->
    <make-invoice-dialog
      ref="invoice"
      view-source="internalBillInfo"
      :location="location"
      @reloadData="reloadBillHandler"
    />
    <!-- 开票申请审批流 -->
    <!-- 账单弹窗 -->
    <bill-work-flow-apply-dialog
      v-if="workFlowApplyDialog.visible"
      ref="billDialog"
      :is-bpm="true"
      :process-info="workFlowApplyDialog.documentProcess"
      :records="workFlowApplyDialog.approvalCommentsRecords"
      type="approve"
      :visible.sync="workFlowApplyDialog.visible"
      :billing-uuid="workFlowApplyDialog.documentProcess.docId"
      :is-view="true"
      @close="workFlowApplyDialog.visible=false"
      @closeAndRefresh="()=> {
        workFlowApplyDialog.visible=false
        pm.loadBilling()
      }"
    />
    <!-- 多条业务 配置规则验证弹窗 -->
    <batch-checking-window
      v-if="batchCheckingWindow.visible"
      :visible.sync="batchCheckingWindow.visible"
      :lob="job.lob"
      :jobs="batchCheckingWindow.jobs"
      :check-node="batchCheckingWindow.checkNode"
      :call-back="batchCheckingWindow.callBack"
      :call-back2="batchCheckingWindow.callBack2"
    />

    <!-- 单条业务 配置规则验证弹窗-->
    <checking-window
      v-if="checkingWindow.visible"
      :visible.sync="checkingWindow.visible"
      :lob="job.lob"
      :job="checkingWindow.job"
      :check-node="checkingWindow.checkNode"
      :call-back="checkingWindow.callBack"
      :call-back2="checkingWindow.callBack2"
    />
  </div>
</template>

<script>

import cargoUpDownResize from '@/components/Cargo/Common/cargoUpDownResize'
import settlementSelectDialog from '@/components/Cargo/Job/settlementSelectDialog'
import { InternalBillInfoBase } from './internalBillInfoBase'
import ColumnUtils from '@/utils/ColumnUtils'
import { basicCacheKeys as TYPE_NAMES } from '@/utils/cacheConfig'
import { AbstractEntity as Job } from '@/class/model/AbstractEntity'
import BillDialog from '@/components/Cargo/Act/billDialog'
import splitBillDialog from '@/components/Cargo/Act/splitBillDialog'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import { formatNumberToThousands } from '@/utils'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import BillPaymentDialog from '@/views/cargo/v0/Clearing/components/BillPayment/billPaymentDialog'
import newBillPaymentDialog from '@/views/cargo/v0/Clearing/components/BillPayment/siRui/newBillPayMentDialog'
import billPaymentDetailForH5 from '@/views/cargo/v0/Clearing/components/BillPayment/siRui/billPaymentDetail'
import { StimulSoftUtil } from '@/class/cargo/model/utils/StimulSoftUtil'
import { PrintTemplateManager } from '@/class/cargo/model/utils/PrintTemplateManager'
import * as BillingConstants from '@/class/cargo/model/parameters/BillingConstants'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { ClearingUtils } from '@/class/cargo/model/utils/ClearingUtils'
import { batchConfirmBilling, recheckBilling, setBillingsNo } from '@/api/clearing/billingNative'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import makeInvoiceDialog from '@/views/cargo/v0/Clearing/components/makeInvoice/makeInvoiceDialog'
import { BPM_STATES_UN_APPROVED } from '@/class/cargo/model/parameters/SystemConstants'
import {
  APPLICATION_DIMENSION_BILL,
  MAKE_INVOICE,
  MAKE_INVOICE_BILLING
} from '@/class/cargo/model/parameters/WorkflowConstants'
import { workflowAction, workflowCheck } from '@/api/workflow'
import { WorkflowUtil } from '@/class/cargo/model/utils/WorkflowUtil'
import BillWorkFlowApplyDialog from '@/components/Cargo/Act/billDialog'
import { DocumentManage } from '@/utils/commonUtil'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import BatchCheckingWindow from '@/components/Cargo/Job/CheckingManager/BatchCheckingWindow.vue'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import { getJobByKeys } from '@/api/booking/job'
import { cache } from '@/utils/cacheManager'
import { getChargeByBillUuid } from '@/api/clearing/charge'
import * as DocumentConstants from '@/class/cargo/model/parameters/DocumentConstants'
import CheckingWindow from '@/components/Cargo/Job/CheckingManager/CheckingWindow.vue'
import { checkConfirmBilling } from '@/api/clearing/invoice'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { getJobInstructions } from '@/api/sysManage/uiCustom'
import OperateBillDialog from '@/components/Cargo/Act/operateBillDialog'
import lodash from 'lodash'

export default {
  name: 'InternalBillInfo',
  components: {
    OperateBillDialog,
    CheckingWindow,
    BatchCheckingWindow,
    CargoButtonGroupSlider, BillDialog, cargoUpDownResize, settlementSelectDialog, cargoTemplateSelectorDialog, BillPaymentDialog,
    newBillPaymentDialog, billPaymentDetailForH5, splitBillDialog, makeInvoiceDialog, BillWorkFlowApplyDialog
  },
  props: {
    context: {
      type: Object,
      required: false
    },
    action: {
      type: String,
      required: true
    },
    location: { type: String, required: false },
    enableUiCustom: { type: Boolean, default: false }, // 是否启用UI自定义
    pageType: { type: Number, default: 0 } // UI自定义页签类型
  },
  data() {
    return {
      loading: null,
      masterFlag: false,
      selectedDataList: [],
      up: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          context: {
            componentParent: this
          },
          onRowClicked: p => { this.pm.dgBillingItemClickHandler(p) },
          onRowSelected: p => { this.pm.onRowSelected(p) }
        },
        columnDefs: [
          {
            headerName: '',
            field: '',
            width: 65,
            headerCheckboxSelection: true,
            checkboxSelection: true,
            sortable: false,
            suppressMenu: true,
            suppressSizeToFit: true,
            resizable: false
          },
          {
            headerName: this.$t('FinanceManage.domestic_billNo'),
            field: 'billingNo',
            width: 150
          },
          {
            headerName: this.$t('FinanceManage.domestic_settleAccountTto'),
            field: 'accountId',
            width: 150,
            cellRenderer: (params) => {
              return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_accountId')
            }
          },
          {
            headerName: this.$t('FinanceManage.domestic_settlementAgent'),
            field: 'settlementAgentId',
            width: 150,
            cellRenderer: (params) => {
              return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_accountId')
            }
          },
          {
            headerName: this.$t('FinanceManage.domestic_invoiceHeader'),
            field: 'title',
            width: 120
          },
          {
            headerName: this.$t('FinanceManage.domestic_currency'),
            field: 'currency',
            width: 100
          },
          {
            headerName: this.$t('FinanceManage.domestic_chargeAmount'),
            field: 'amount',
            width: 110,
            cellClass: 'ag-right-aligned-cell',
            cellRenderer: (params) => {
              return ColumnUtils.number2ColumnLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('FinanceManage.domestic_totalCurrency'),
            field: 'currencyAmount',
            width: 120
          },
          {
            headerName: this.$t('FinanceManage.domestic_revenueAndExpenditureType'),
            field: 'ar',
            width: 120,
            cellRenderer: (params) => {
              return this.isArLabFun(params.value)
            }
          },
          {
            headerName: this.$t('FinanceManage.international_status'),
            field: 'state',
            width: 120,
            cellRenderer: (params) => {
              return ColumnUtils.billingStateLabelFun(params.value)
            }
          },
          {
            headerName: this.$t('FinanceManage.domestic_invoicingStatus'),
            field: 'invoiceState',
            width: 120,
            cellRenderer: (params) => {
              return ColumnUtils.invoiceStateLabelFun(params.value)
            }
          },
          {
            headerName: this.$t('FinanceManage.domestic_writeOffStatus'),
            field: 'realClearingState',
            width: 120,
            cellRenderer: (params) => {
              return ColumnUtils.clearingStateLabFun(params.value)
            }
          },
          {
            headerName: this.$t('FinanceManage.domestic_billingGroupNo'),
            field: 'billingGroupNo',
            width: 120
          },
          {
            headerName: this.$t('FinanceManage.international_agentBillNo'),
            field: 'counterPartyBillingNo',
            width: 120,
            hide: true
          },
          {
            headerName: this.$t('CargoMsg.Cargo_InvoiceType'), field: 'invoiceType', colId: 'invoiceType', width: 120, hide: true
          },
          {
            headerName: this.$t('Invoice.invoice_invoiceCategory'), field: 'invoiceMakeType', colId: 'invoiceMakeType', width: 120, hide: true
          },
          {
            headerName: this.$t('FinanceManage.international_creator'),
            field: 'inputBy',
            width: 150,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('Billing.billingJob_confirmDate'), field: 'confirmDate', colId: 'confirmDate', width: 120,
            cellRenderer: (params) => {
              return ColumnUtils.dateTimeLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_DueDate'),
            field: 'dueDate',
            width: 120,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('CargoMsg.Carge_BillingConfirmUser'), field: 'confirmUser', colId: 'confirmUser', width: 120,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('FinanceManage.charge_confirmOrNot'), field: 'confirmed', colId: 'confirmed', width: 120,
            cellRenderer: (params) => {
              return ColumnUtils.booleanLabelFunction(params.value)
            }
          },
          {
            headerName: this.$t('Billing.billing_recheckStatus'), field: 'review', colId: 'review', width: 120,
            cellRenderer: (params) => {
              return ColumnUtils.billingReviewLabelFunc(params.value)
            }
          }, {
            headerName: this.$t('Billing.billing_reviewPeople'),
            field: 'reviewBy',
            width: 200,
            cellRenderer: params => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          }, {
            headerName: this.$t('Billing.billing_reviewDate'),
            field: 'reviewDate',
            width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.dateTimeLabelFunc(params.value)
            }
          }, {
            headerName: this.$t('Billing.BillSettlementType'),
            field: 'settlementType',
            width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.billSettlementTypeLableFun(params.value)
            }
          }, {
            headerName: this.$t('CargoMsg.Cargo_ApprovalStatus'),
            field: 'approvalStatus',
            width: 100,
            cellRenderer: (params) => {
              return ColumnUtils.approvalStatusLabelFun(params.value)
            },
            hide: true
          },
          {
            headerName: this.$t('CargoMsg.Cargo_InvalidOrNot'),
            field: 'revoked',
            width: 120,
            cellRenderer: (params) => {
              return ColumnUtils.booleanLabelFunction(params.value)
            },
            hide: true
          }
        ],
        rowData: [],
        gridApi: null
      },
      down: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          context: {
            componentParent: this
          }
        },
        rowData: [],
        gridApi: null
      },
      settlementSelectDialog: {
        visible: false,
        title: '',
        accounts: [],
        settlements: []
      },
      pm: new InternalBillInfoBase(this),
      btnEnable: {
        btnConfrim: false,
        btnAccountAdd: false,
        btnPayAdd: false,
        btnEdit: false,
        btnDel: false,
        btnView: false,
        ddlBranchId: false,
        payauthFromBilling: false,
        btnRecheck: false,
        btnCancelRecheck: false,
        btnInvalidShow: false,
        btnInvalidEnable: false
      },
      job: new Job().fillDefaultValue().getData(),
      cbShowSelfChanges: false, // 仅显示本委托费用
      cbShowAllBilling: false, // 是否显示所有账单
      specialBillingBranchId: 0, // 默认账单所属分公司
      cbShowInternal: true, // 内结费用
      controllerVisible: {
        cbShowSelfChanges: false,
        showSpecialCharge: false,
        cbShowInternal: false
      },
      selectedBilling: null,
      billingList: [],
      chargeList: [],
      billDialog: { // 账单弹出框
        visible: false,
        billingUuid: '',
        isView: false,
        createBillWay: 0,
        accounts: [],
        slaveCharges: [],
        instructionBtns: []
      },
      newBillDialog: { // 账单弹出框
        visible: false,
        customerDetail: {},
        billingUuid: '',
        isView: false
      },
      templateSelectorDialog: {// 模板选择弹窗
        visible: false,
        ctx: null,
        category: '',
        data: {}
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      printCategory: 'BILLING',
      INTERNALBILLING: 'INTERNALBILLING',
      BILLING: 'BILLING',
      printEvent: null, // print callback
      showBillPaymentDialog: false,
      billPaymentDialogUuid: '',
      billPaymentDialogForH5: { // 付款申请-H5 弹窗变量
        visible: false,
        title: this.$t('CargoMsg.Cargo_CreatePaymentRequestChooseFees'),
        source: 'tabBilling',
        uuid: '',
        defaultConditions: {
          exceptKeys: [],
          hasBillPayment: -1,
          hasBilling: -1,
          oversea: -1,
          accountId: 0,
          billingKeys: [] // 账单UUID
        },
        billPaymentDetailProperties: {
          visible: false,
          title: '',
          uuid: '',
          state: -1,
          charges: [],
          chargesDirty: false,
          billPaymentDirty: false,
          inputBy: 0
        }
      },
      makeInvoiceProperties: { // 开票动作传递的参数
        keys: [], // 此处统一传递uuid集合，后续会请求后台，组装树状结构
        isAr: false,
        step: '',
        hedgeKeys: [], // 对冲开票uuid集合
        isHedge: false,
        isSkipInvoiceFrom: false,
        makeInvoiceMethod: 3, // 开票方式:3代表账单
        selectedEntities: []
      },
      workFlowApplyDialog: {
        visible: false
      },
      documentManage: new DocumentManage(),
      isBpmEnabled: false,
      batchCheckingWindow: {
        visible: false,
        jobs: [],
        checkNode: 0,
        callBack: null,
        callBack2: null,
        billDataList: []
      },
      checkingWindow: {
        visible: false,
        checkNode: 0,
        job: null,
        callBack: null,
        callBack2: null
      },
      btnConfimKeys: [],
      btnRecheckBillings: [],
      instructioinBtns: [],
      operateBillDialog: { // 操作指令账单弹出框
        visible: false,
        needTips: false // 保存是否需要二次确认
      },
      billElementDict: {},
      detailElementDict: {},
      billPageSet: { newReceiveHide: false, newPayHide: false, editHide: false } // 海出-账单页签设置
    }
  },
  computed: {
    readonly() {
      return this.action === 'look'
    },
    isEdit() {
      return this.action !== 'look'
    },
    user() {
      return this.context.user || {}
    },
    officeList() {
      return this.context.officeList
    },
    showWhtTax() {
      return this.$store.getters.currentOffice.whtTaxMode
    },
    upColumnDefs() {
      let result = [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('FinanceManage.domestic_billNo'),
          field: 'billingNo',
          width: 150
        },
        {
          headerName: this.$t('FinanceManage.domestic_settleAccountTto'),
          field: 'accountId',
          width: 150,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_accountId')
          }
        },
        {
          headerName: this.$t('FinanceManage.domestic_settlementAgent'),
          field: 'settlementAgentId',
          width: 150,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_accountId')
          }
        },
        {
          headerName: this.$t('FinanceManage.domestic_invoiceHeader'),
          field: 'title',
          width: 120
        },
        {
          headerName: this.$t('FinanceManage.domestic_currency'),
          field: 'currency',
          width: 100
        },
        {
          headerName: this.$t('FinanceManage.domestic_chargeAmount'),
          field: 'amount',
          width: 110,
          cellClass: 'ag-right-aligned-cell',
          cellRenderer: (params) => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('FinanceManage.domestic_totalCurrency'),
          field: 'currencyAmount',
          width: 120
        },
        {
          headerName: this.$t('FinanceManage.domestic_revenueAndExpenditureType'),
          field: 'ar',
          width: 120,
          cellRenderer: (params) => {
            return this.isArLabFun(params.value)
          }
        },
        {
          headerName: this.$t('FinanceManage.international_status'),
          field: 'state',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.billingStateLabelFun(params.value)
          }
        },
        {
          headerName: this.$t('FinanceManage.domestic_invoicingStatus'),
          field: 'invoiceState',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.invoiceStateLabelFun(params.value)
          }
        },
        {
          headerName: this.$t('FinanceManage.domestic_writeOffStatus'),
          field: 'realClearingState',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.clearingStateLabFun(params.value)
          }
        },
        {
          headerName: this.$t('FinanceManage.domestic_billingGroupNo'),
          field: 'billingGroupNo',
          width: 120
        },
        {
          headerName: this.$t('FinanceManage.international_agentBillNo'),
          field: 'counterPartyBillingNo',
          width: 120,
          hide: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_InvoiceType'), field: 'invoiceType', colId: 'invoiceType', width: 120, hide: true
        },
        {
          headerName: this.$t('Invoice.invoice_invoiceCategory'), field: 'invoiceMakeType', colId: 'invoiceMakeType', width: 120, hide: true
        },
        {
          headerName: this.$t('FinanceManage.international_creator'),
          field: 'inputBy',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Billing.billingJob_confirmDate'), field: 'confirmDate', colId: 'confirmDate', width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DueDate'),
          field: 'dueDate',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Carge_BillingConfirmUser'), field: 'confirmUser', colId: 'confirmUser', width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_confirmOrNot'), field: 'confirmed', colId: 'confirmed', width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          }
        },
        {
          headerName: this.$t('Billing.billing_recheckStatus'), field: 'review', colId: 'review', width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.billingReviewLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('Billing.billing_reviewPeople'),
          field: 'reviewBy',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('Billing.billing_reviewDate'),
          field: 'reviewDate',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('Billing.BillSettlementType'),
          field: 'settlementType',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.billSettlementTypeLableFun(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ApprovalStatus'),
          field: 'approvalStatus',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.approvalStatusLabelFun(params.value)
          },
          hide: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_InvalidOrNot'),
          field: 'revoked',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          },
          hide: true
        }
      ]
      if (this.showWhtTax) {
        result.push(
          {
            headerName: this.$t('FinanceManage.charge_whtTaxAmount'),
            field: 'whtTaxLocalAmount',
            width: 100,
            valueFormatter: (params) => {
              return ColumnUtils.numberColumnLabelFunc(params.value, 2)
            }
          }, {
            headerName: this.$t('FinanceManage.charge_notWhtAmount'),
            field: 'notWhtAmount',
            width: 200,
            valueFormatter: (params) => {
              return this.$numeral(params.value).format('0.00')
            }
          })
      }
      if (this.enableUiCustom) {
        result = UICustomUtil.handleColumnLabelAndDisplay(result, this.billElementDict)
      }
      return result
    },
    downColumnDefs() {
      let result = [
        {
          headerName: this.$t('FinanceManage.international_businessNumber'),
          field: 'jobNo',
          width: 150
        },
        {
          headerName: this.$t('FinanceManage.domestic_revenueOrExpenditure'),
          field: 'receivable',
          width: 100,
          cellRenderer: (params) => {
            return this.isArLabFun(params.value)
          }
        },
        {
          headerName: this.$t('FinanceManage.domestic_chargeItem'),
          field: 'chargeItemId',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          }
        },
        {
          headerName: this.$t('FinanceManage.domestic_currency'),
          field: 'currency',
          width: 100
        },
        {
          headerName: this.$t('FinanceManage.domestic_unit'),
          field: 'measure',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'code', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('FinanceManage.domestic_amount'),
          field: 'quantity',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('FinanceManage.domestic_unitPrice'),
          field: 'unitRate',
          width: 110,
          cellClass: 'ag-right-aligned-cell',
          cellRenderer: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('FinanceManage.domestic_taxIncludedPrice'),
          field: 'amount',
          width: 100,
          cellClass: 'ag-right-aligned-cell',
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value))
          }
        },
        {
          headerName: this.$t('FinanceManage.domestic_taxExcludedPrice'),
          field: 'excludingTaxAmount',
          width: 120,
          cellClass: 'ag-right-aligned-cell',
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value))
          }
        },
        {
          headerName: this.$t('FinanceManage.domestic_taxRate'),
          field: 'taxRate',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('FinanceManage.domestic_taxAmount'),
          field: 'taxAmount',
          width: 100,
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value))
          }
        },
        {
          headerName: this.$t('FinanceManage.domestic_remarks'),
          field: 'remarks',
          width: 100
        },
        {
          headerName: this.$t('FinanceManage.charge_invoiceHeader'),
          field: 'invoiceTitle',
          hide: true,
          width: 100
        }, {
          headerName: this.$t('FinanceManage.international_settlementAgent'),
          field: 'settlementAgentId',
          width: 150,
          hide: true,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_accountId')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Business_CustomerRefNo'),
          field: 'jobCustomerRefNo',
          width: 200
        }
      ]
      if (this.showWhtTax) {
        result.push({
          headerName: this.$t('FinanceManage.charge_whtTaxRate'),
          field: 'whtTaxRate',
          width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2)
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_whtTaxAmount'),
          field: 'whtTaxLocalAmount',
          width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2)
          }
        }, {
          headerName: this.$t('FinanceManage.charge_notWhtAmount'),
          field: 'notWhtAmount',
          width: 200,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          }
        })
      }
      if (this.enableUiCustom) {
        result = UICustomUtil.handleColumnLabelAndDisplay(result, this.detailElementDict)
      }
      return result
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      immediate: true,
      handler() {
        this.loadPageConfig()
        this.loadPageSet()
      }
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('showWorkFlowApplyDialog', function(documentProcessId) {
      WorkflowUtil.showWorkFlowApplyDialog(context, context.workFlowApplyDialog, 'workFlowApplyDialog', documentProcessId)
    })
  },
  async created() {
    this.isBpmEnabled = await WorkflowUtil.isBpmEnabled({
      documentConfigId: MAKE_INVOICE.code,
      officeId: this.$store.getters.currentOfficeId,
      formSubtype: MAKE_INVOICE_BILLING.code
    })
    if (this.isBpmEnabled) {
      this.up.columnDefs.push({
        headerName: this.$t('CargoMsg.Cargo_ApprovalSerialNumber'),
        field: 'documentProcessNo',
        colId: 'documentProcessNo',
        width: 200,
        hide: true,
        excelRenderer: (params) => {
          if (params.value) {
            return params.value
          }
          return ''
        },
        cellRenderer: (params) => {
          if (params.value) {
            const methodPath = this.documentManage.getPath('showWorkFlowApplyDialog')
            return `<a onclick="${methodPath}(${params.data.documentProcessId})" style="color:blue">` + params.value + '</a>'
          }
          return ''
        },
        filterParams: {},
        filterValueGetter: (params) => {
          return params.data.documentProcessNo ? params.data.documentProcessNo : ''
        }
      })
    }
  },
  methods: {
    openInvoiceDetails(invoiceUuids) {
      if (this.$refs.invoice && this.$refs.invoice.openInvoiceDetails) {
        return this.$refs.invoice.openInvoiceDetails(invoiceUuids)
      }
      return null
    },
    loadPageConfig() {
      if (!this.enableUiCustom) {
        return
      }
      this.billElementDict = UICustomUtil.getPageConfig(this.pageType, this.$store.getters.currentOfficeId, undefined, 'InternalBillInfo').elementDict
      this.detailElementDict = UICustomUtil.getPageConfig(this.pageType, this.$store.getters.currentOfficeId, undefined, 'BillingDetails').elementDict
    },
    loadPageSet() {
      if (!this.enableUiCustom) {
        return
      }
      this.billPageSet = UICustomUtil.getInternalBillPageSet(this.pageType)
    },
    async onShow(row) {
      this.loading = getLoading4Cxt(this)
      try {
        this.masterFlag = row.masterFlag || false
        this.job = row
        // 初始赋值，避免changeJob 后值仍保留上次的值
        this.selectedBilling = null
        this.selectedDataList = []
        this.billingList = []
        this.chargeList = []
        this.pm.refreshGrid() // 刷新表格并清除选中
        await this.pm.initializeHandler()
        await this.pm.commitProperties()
        this.loadInstructionBtns()
        if (this.enableUiCustom) {
          UICustomUtil.handleViewAndWrite(this.pageType, this.billElementDict, row)
          UICustomUtil.handleViewAndWrite(this.pageType, this.detailElementDict, row)
        }
      } finally {
        this.loading.close()
      }
    },
    // 收支类型
    isArLabFun(value) {
      return value ? this.$t('Message.Receivable') : this.$t('Message.Payable')
    },
    // 选择结算单位后事件处理
    selectItemWinHandler(accountId, createBillWay) {
      this.pm.loadAccountCompany(accountId, createBillWay)
    },
    // 创建账单-点击返回按钮
    reloadBillHandler() {
      this.context.reloadCharge = true
      this.billDialog.visible = false
      this.newBillDialog.visible = false
      this.operateBillDialog.visible = false
      this.pm.loadBilling()
    },
    // todo 组装打印参数
    getPrintData() {
      if (!this.up.gridApi) {
        this.$message.warning(this.$t('Message.NoSelectedBill'))
        return
      }
      const selectList = this.up.gridApi.getSelectedRows()
      if (selectList && selectList.length <= 0 && !this.selectedBilling) {
        this.$message.warning(this.$t('Message.NoSelectedBill'))
        return
      }
      // 如果是配置参数只允许打印一个的话：
      if (this.pm.isBulkPrint) {
        this.print()
      } else {
        // 这个分两种情况 勾选 和 选中 优先选中
        if (selectList.length > 1) {
          this.printBillingHandler()
        } else if (selectList.length === 1 || this.selectedBilling) {
          this.print()
        }
      }
      return null
    },
    print() {
      const selectList = this.up.gridApi.getSelectedRows()
      // 这边只支持单个打印 优先选中
      let bill = null
      if (selectList.length > 1) {
        return
      } else if (this.selectedBilling) {
        bill = this.selectedBilling
      } else if (selectList.length === 1) {
        bill = selectList[0]
        this.pm.setGridSelect(bill)
      }
      if (bill) {
        // TemplateSelectorWin.getInstance().showThisWin(job, "INTERNALBILLING", params, this);
        const params = {}
        params.BILLING_UUID = bill.uuid
        params.printSource = DocumentConstants.BUSINESS_BILL_PRINT.code
        params.CONFIRM_BILL_ID = bill.uuid
        params.CONFIRM_BILL_UUID = bill.uuid
        if (this.job) {
          params.jobuuid = this.job.uuid
          params.jobNo = this.job.jobNo
        }
        params.fileAliasName = bill.billingNo
        // CARGO-6000，圣世特：V2模板，国内账单另存文件，文件名需要由模板名称+账单号组成
        params.billingNo = bill.billingNo
        params.ctx = JobUtils.getJobByType(this.job)
        this.$logger.log('===print=params===', params)
        // 组装回调函数
        this.templateSelectorDialog.ctx = Object.prototype.hasOwnProperty.call(params, 'ctx') ? params.ctx : null
        if (Object.prototype.hasOwnProperty(params, 'ctx')) delete params.ctx
        this.templateSelectorDialog.category = 'INTERNALBILLING'
        this.templateSelectorDialog.data = params
        this.templateSelectorDialog.visible = true
      }
    },
    // 打印账单
    printBillingHandler() {
      const billings = this.up.gridApi.getSelectedRows()
      if (billings.length <= 0) {
        this.$message.info('请选择账单.')
        return
      }

      const keyList = Array.from(billings, p => p.uuid)
      const params = {}
      params.BILLING_UUID_LIST = keyList
      params.BILLING_UUID = params.BILLING_UUID_LIST
      params.printSource = DocumentConstants.BUSINESS_BILL_PRINT.code
      // CARGO-32068 天津中船14475：批量打印账单，无法将生成的文件至文件历史中
      if (this.job) {
        params.uploadJobFileHistoryParam = { jobNo: this.job.jobNo }
      }
      const billing = billings[0]
      if (billing.billingType === BillingConstants.BILLING_TYPE_INTERNAL.code) {
        // CARGO-6000，圣世特：V2模板，国内账单另存文件，文件名需要由模板名称+账单号组成
        if (billings.length === 1) {
          params.billingNo = billing.billingNo
          if (billing.jobUuid && this.job) {
            params.jobNo = this.job.jobNo
          }
        }
        params.category = this.INTERNALBILLING
        this.prePrintCallback = null
        // TemplateSelectorWin.getInstance().showThisWin(null, INTERNALBILLING, params, this);
      } else {
        params.category = this.BILLING
        this.prePrintCallback = this.prePrint
        // TemplateSelectorWin.getInstance().showThisWin(null, BILLING, params, this, prePrint);
      }
      this.$logger.log('===printBillingHandler=params===', params)
      this.templateSelectorDialog.ctx = null
      this.templateSelectorDialog.category = params.category
      this.templateSelectorDialog.data = params
      this.templateSelectorDialog.visible = true
    },
    // 打印动作
    prePrint(printEvent) {
      const billings = this.up.gridApi.getSelectedRows()
      let needSet = false
      for (const billing of billings) {
        if (!billing.billingNo) {
          needSet = true
          break
        }
      }
      const billingMap = new Map()
      for (const billing of billings) {
        if (billingMap.has(billing.uuid)) continue
        billingMap.set(billing.uuid, billing)
      }
      if (needSet) {
        setBillingsNo(billings).then(res => {
          // 加载费用后赋值给bill 费用List属性上
          const bills = res.data
          if (bills && bills.length > 0) {
            for (const billing of bills) {
              if (billingMap.has(billing.uuid) && billingMap.get(billing.uuid)) {
                const oldBill = billingMap.get(billing.uuid)
                Object.assign(oldBill, billing)
              }
            }
          }
          this.doPrint(this.selectedBilling, printEvent)
        })
      } else {
        this.doPrint(this.selectedBilling, printEvent)
      }
    },
    // 账单打印使用
    doPrint(billing, printEvent) {
      if (!printEvent) return
      if (printEvent.template && StimulSoftUtil.isOpenStiReport(printEvent.template)) {
        this.$nextTick(async() => {
          const res = await this.$refs['templateDialog'].printFileV2(printEvent)
          if (printEvent.exportType) {
            this.$refs['templateDialog'].handlePrintResult(res)
          }
        })
      } else {
        const printType = printEvent.parameter.printType
        printEvent.parameter.fileAliasName = billing.billingNo
        if (printType === PrintTemplateManager.EMAIL) {
          // FlexGlobals.topLevelApplication.appView.selectedChild.saveSendEmailFile()
          this.$nextTick(() => {
            this.$refs['templateDialog'].sendEmailTriggerEventHandler(printEvent)
          })
        } else if (printType === PrintTemplateManager.FAX) {
          // 传真有说不加了【无需验证】
          // FlexGlobals.topLevelApplication.appView.selectedChild.saveSendFaxFile()
          PrintTemplateManager.fax(printEvent.template, PrintTemplateManager.FORMAT_PDF, printEvent.parameter)
        } else {
          PrintTemplateManager.print(printEvent.template, printEvent.documentType, printEvent.format, printEvent.parameter, printEvent.action === 'print')
        }
      }
    },
    /**
   * 申请付款
   */
    async applyForPayment() {
      const chooseRows = this.up.gridApi.getSelectedRows()
      if (chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBill'))
        return
      }
      if (chooseRows[0].branchId !== this.$store.getters.currentOfficeId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckChargeDetailBranch'))
        return
      }
      const isSameAccount = ClearingUtils.isSameAccount(chooseRows)
      const isSameSettlementAgent = isSameAccount ? false : ClearingUtils.isSameSettlementAgent(chooseRows)
      if (!isSameAccount && !isSameSettlementAgent) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SettlingPartyOrSettlementAgentInconsistent'))
        return
      }
      if (!ClearingUtils.createBillPaymentCheckBillingState(chooseRows)) return
      const charges = await ClearingUtils.createBillPaymentByBilling(chooseRows, -1, 'InternalBill')
      if (charges && charges.length > 0) {
        const notPaymentBillingKeys = []
        for (const charge of charges) {
          if (!charge.billPaymentUuid) {
            notPaymentBillingKeys.push(charge.chargeBillUuid)
          }
        }
        if (notPaymentBillingKeys.length === 0) {
          this.billPaymentDialogUuid = charges[0].billPaymentUuid
          this.showBillPaymentDialog = true
        } else {
          this.billPaymentDialogForH5.defaultConditions.billingKeys = notPaymentBillingKeys
          this.billPaymentDialogForH5.visible = true
        }
      }
    },
    // 选择费用创建付款申请-H5 下一步回调
    async nextCreateBillPaymentCallback(charges) {
      if (charges && charges.length > 0) {
        // 隐藏创建弹窗
        this.billPaymentDialogForH5.visible = false
        // 展示详情弹窗
        this.showBillPaymentDialog = true
        this.$refs.billPayment.initBillPayment(charges)
      }
    },
    // 创建付款申请-H5第二步回退至第一步
    toPreStep() {
      this.billPaymentDialogForH5.billPaymentDetailProperties.visible = false
      this.billPaymentDialogForH5.visible = true
    },
    // 刷新界面
    refreshBillPaymentH5(billPayment) {
      this.billPaymentDialogForH5.billPaymentDetailProperties.visible = false
      this.billPaymentDialogForH5.billPaymentDetailProperties.uuid = billPayment ? billPayment.uuid : ''
      this.billPaymentDialogForH5.billPaymentDetailProperties.visible = true
      this.billPaymentDialogForH5.billPaymentDetailProperties.state = billPayment ? billPayment.state : -1
      this.billPaymentDialogForH5.billPaymentDetailProperties.inputBy = billPayment ? billPayment.inputBy : 0
      this.billPaymentDialogForH5.billPaymentDetailProperties.title = this.$t('CargoMsg.Cargo_ViewPaymentRequest')
      this.$refs.billPaymentDetailForH5.reloadData()
    },
    // 开票
    async toMakeInvoice(bill, closeBillDialogFunc) {
      if (bill.state === 0) {
        await this.$confirm(this.$t('Invoice.existUnconfirmedStatus'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        })
      }
      if (bill.branchId !== this.$store.getters.currentOfficeId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckChargeDetailBranch'))
        return
      }
      closeBillDialogFunc()
      const selectedBill = this.normalizeBillInvoiceTypeByTaxRate(bill)
      this.makeInvoiceProperties.isAr = bill.ar
      this.makeInvoiceProperties.keys = [bill.uuid]
      this.makeInvoiceProperties.step = 'step1'
      this.makeInvoiceProperties.selectedEntities = [selectedBill]
      await this.$refs.invoice.makeInvoice({ ...this.makeInvoiceProperties })
    },
    // 开票（发起bpm）
    async toMakeInvoiceWithBpm(bill, closeBillDialogFunc) {
      if (bill.state === 0) {
        await this.$confirm(this.$t('Invoice.existUnconfirmedStatus'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        })
      }
      if (bill.branchId !== this.$store.getters.currentOfficeId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckChargeDetailBranch'))
        return
      }
      closeBillDialogFunc()
      // 应收 且 账单【开票申请】触发bpm节点 是否 开启
      if (bill.ar && this.pm.billingTriggerBpm) {
        // 是否 已经存在 【审批实例】
        if (!!bill.approvalStatus && bill.approvalStatus !== BPM_STATES_UN_APPROVED.code) {
          await this.$confirm(this.$t('CargoMsg.Cargo_BillHasBeenInitiatedForApproval'), this.$t('Message.Prompt'), {
            confirmButtonText: this.$t('Message.GotIt'),
            showCancelButton: false,
            type: 'warning'
          })
          return
        }
        // 是否 存在 【开票】相关的审批流
        if (await WorkflowUtil.isBpmEnabled({ documentConfigId: MAKE_INVOICE.code, officeId: bill.branchId })) {
          // 点击确认之后往下执行
          await this.$confirm(this.$t('CargoMsg.Cargo_SubmitInvoiceTip'), this.$t('Message.Prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            showCancelButton: true,
            type: 'warning'
          })
          const params = {
            documentConfigId: MAKE_INVOICE.code,
            docId: bill.uuid,
            officeId: bill.branchId,
            applicationDimension: APPLICATION_DIMENSION_BILL.code,
            formSubtype: MAKE_INVOICE_BILLING.code
          }
          this.loading = getLoading()
          await workflowCheck(params).then(async res => {
            if (res.data && res.data.skipApprove) {
              this.pm.loadBilling()
              const selectedBill = this.normalizeBillInvoiceTypeByTaxRate(bill)
              this.makeInvoiceProperties.isAr = bill.ar
              this.makeInvoiceProperties.keys = [bill.uuid]
              this.makeInvoiceProperties.step = 'step1'
              this.makeInvoiceProperties.selectedEntities = [selectedBill]
              await this.$refs.invoice.makeInvoice({ ...this.makeInvoiceProperties })
              return
            }
            if (res.data && res.data.actions && res.data.actions.length > 0) {
              const commitActions = res.data.actions.filter(btn => btn.actionType === 7000)
              // 提交 bpm
              if (commitActions.length > 0) {
                // this.loading = getLoading()
                const commitParams = {
                  documentConfigId: MAKE_INVOICE.code,
                  docId: bill.uuid,
                  docNo: bill.billingNo,
                  actionId: commitActions[0].id,
                  actionType: commitActions[0].actionType,
                  officeId: bill.branchId,
                  applicationDimension: APPLICATION_DIMENSION_BILL.code
                }
                await workflowAction(commitParams).then(res => {
                  this.$message.success(commitActions[0].actionName + this.$t('CargoMsg.Cargo_ApprovedSuccess'))
                  this.pm.loadBilling()
                }).catch(reason => {
                })
              }
            }
          }).finally(() => {
            this.loading.close()
          })
          return
        }
      }
      const selectedBill = this.normalizeBillInvoiceTypeByTaxRate(bill)
      this.makeInvoiceProperties.isAr = bill.ar
      this.makeInvoiceProperties.keys = [bill.uuid]
      this.makeInvoiceProperties.step = 'step1'
      this.makeInvoiceProperties.selectedEntities = [selectedBill]
      await this.$refs.invoice.makeInvoice({ ...this.makeInvoiceProperties })
    },
    normalizeBillInvoiceTypeByTaxRate(bill) {
      if (!bill || !bill.ar) {
        return bill
      }
      const rawTaxRate = bill.taxRate !== undefined && bill.taxRate !== null && bill.taxRate !== ''
        ? bill.taxRate
        : bill.chargeTaxRate
      if (rawTaxRate === undefined || rawTaxRate === null || rawTaxRate === '') {
        return bill
      }
      const taxRateValue = Number(String(rawTaxRate).replace('%', '').replace(/[^\d.-]/g, '').trim())
      if (Number.isNaN(taxRateValue)) {
        return bill
      }
      return {
        ...bill,
        invoiceType: taxRateValue > 0 ? 6 : 7
      }
    },
    // 取消事件
    cancel() {
      this.showBillPaymentDialog = false
      this.billPaymentDialogUuid = ''
    },
    // PILL-80 GP率预警加相关校验 该方法为在原本的处理逻辑上添加一层规则校验 该按钮的验证规则节点应该固定只为 CheckRuleConstants.NODE_AR_SURE 或者 CheckRuleConstants.NODE_AP_SURE
    async checkRuleAndConfirm(confirm) {
      // 判断是否开启验证规则
      const useCheckRule = Number(this.context.config.get('useCheckRule')) === 1
      if (useCheckRule) {
        // 查询该分公司配置了是否配置了 CheckRuleConstants.NODE_AR_SURE 或者 CheckRuleConstants.NODE_AP_SURE 节点
        let hasArNode
        let hasApNode
        let hasInternalArNode
        // CARGO-47750 应收账单确认，增加必录项校验“纳税人识别号”、“客户邮箱”
        if (confirm) {
          hasInternalArNode = await JobUtils.hasCheckRuleCondition(true, CheckRuleConstants.NODE_BILL_AR_SURE.code, this.$store.getters.currentOfficeId)
        }
        if (hasInternalArNode) {
          //  校验账单是否全部为应收账单
          const allArByBill = this.selectedDataList.every(item => item.ar)
          const allApByBill = this.selectedDataList.every(item => !item.ar)
          // 全部应付不做处理
          if (allApByBill) {
            this.invokePmConfirmHandle()
            return
          }
          // 全部应收
          if (!allArByBill) {
            this.$message.warning(this.$t('CargoMsg.CheckArApDisparity'))
            return
          }
          // 构建参数发起弹窗
          this.job.internalBillUuidList = this.selectedDataList.map(item => item.uuid)
          this.checkingWindow.checkNode = CheckRuleConstants.NODE_BILL_AR_SURE.code
          this.checkingWindow.job = this.job
          this.checkingWindow.callBack = this.invokePmConfirmHandle
          this.checkingWindow.visible = true
          return
        }
        if (confirm) {
          hasArNode = await JobUtils.hasCheckRuleCondition(true, CheckRuleConstants.NODE_AR_SURE.code, this.$store.getters.currentOfficeId)
          hasApNode = await JobUtils.hasCheckRuleCondition(true, CheckRuleConstants.NODE_AP_SURE.code, this.$store.getters.currentOfficeId)
        } else {
          hasArNode = await JobUtils.hasCheckRuleCondition(true, CheckRuleConstants.NODE_AR_RECHECK.code, this.$store.getters.currentOfficeId)
          hasApNode = await JobUtils.hasCheckRuleCondition(true, CheckRuleConstants.NODE_AP_RECHECK.code, this.$store.getters.currentOfficeId)
        }
        // 使用reduce方法将每个对象的chargeList合并到一个新的数组中
        const combinedChargeList = []
        const jobUuids = []
        let billArr = []

        if (this.selectedDataList && this.selectedDataList.length > 0) {
          billArr = this.selectedDataList
        } else {
          if (this.selectedBilling) {
            billArr.push(this.selectedBilling)
          }
        }
        const list = billArr.map(item => {
          return getChargeByBillUuid(item.uuid)
        })

        const resp = await Promise.all(list)
        resp.forEach(element => {
          if (element.data) {
            element.data.forEach((item) => {
              combinedChargeList.push(item)
              jobUuids.push(item.jobUuid)
            })
          }
        })
        // 判断是否全部为应收
        const allAr = combinedChargeList.every(item => item.receivable === true)
        // 判断是否全部为应付
        const allAp = combinedChargeList.every(item => item.receivable === false)
        //  说明该分公司配置了 CheckRuleConstants.NODE_AR_SURE 或者 CheckRuleConstants.NODE_AP_SURE 节点 那么用户勾选的数据就只能全部为AR或者AP
        if ((hasArNode || hasApNode) && !(allAr || allAp)) {
          this.$message.warning(this.$t('CargoMsg.CheckArApDisparity'))
        } else {
          // 开启了验证规则 就判断当前所选的数据是否全部为应收或者全部为应付
          if (this.nodeArApHandle(hasArNode, hasApNode, allAr, allAp)) {
            // 定义回调方法
            let callBack = null
            if (confirm) {
              callBack = this.invokePmConfirmHandle || null
            } else {
              callBack = this.invokePmRecheckHandle || null
            }
            // 定义节点
            this.batchCheckingWindow.checkNode = allAr ? confirm ? CheckRuleConstants.NODE_AR_SURE.code : CheckRuleConstants.NODE_AR_RECHECK.code : confirm ? CheckRuleConstants.NODE_AP_SURE.code : CheckRuleConstants.NODE_AP_RECHECK.code
            // 取出该账单的费用信息，根据费用的jobUuid查询数据
            // 根据jobUuid查询job的数据返回
            const jobList = await getJobByKeys(jobUuids).then(res => res.data)
            this.batchCheckingWindow.jobs = jobList
            this.batchCheckingWindow.callBack = callBack
            this.batchCheckingWindow.visible = true
          } else {
            // 分公司开启了验证规则配置, 但是未配置该验证节点 或者验证节点 继续走原本逻辑
            if (confirm) {
              this.invokePmConfirmHandle()
            } else {
              this.invokePmRecheckHandle()
            }
          }
        }
      } else {
        // 未开启验证规则就走原本的处理逻辑
        if (confirm) {
          this.invokePmConfirmHandle()
        } else {
          this.invokePmRecheckHandle()
        }
      }
    },
    nodeArApHandle(arNode, apNode, allAr, allAp) {
      const result = false
      if (arNode && allAr) {
        return true
      }
      if (apNode && allAp) {
        return true
      }
      return result
    },
    invokePmConfirmHandle() {
      this.pm.btnConfirmHandle(this.btnConfimKeys)
    },
    invokePmRecheckHandle() {
      this.pm.btnRecheckHandle(this.btnRecheckBillings)
    },
    // 确认按钮
    async btnConfrimClickHandle() {
      const bill = this.selectedBilling
      const chooseRows = this.up.gridApi.getSelectedRows()
      const bs = Number(cache.config.get('BillingNoteContainInvoiceReques'))
      const uuidList = []
      for (let i = 0; i < chooseRows.length; i++) {
        const billing = chooseRows[i]
        if (billing.revoked) {
          this.$message.warning(this.$t('queryJob.InvalidBillCannotConfirm'))
          return
        }
        if (bs && billing.makeInvoiceType === 0 && billing.ar && billing.billingType === BillingConstants.BILLING_TYPE_INTERNAL.code) {
          uuidList.push(billing.uuid)
        }
      }
      if (uuidList && uuidList.length > 0) {
        const res = await checkConfirmBilling(uuidList)
        if (res && res.data && res.data.length > 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_RemarkTip2'))
          return
        }
      }
      this.btnConfimKeys = []
      for (let i = 0; i < chooseRows.length; i++) {
        const billing = chooseRows[i]
        const state = billing.state
        if ((state === Number(BillingConstants.BILLING_NORMAL.code) || !billing.confirmed) && !billing.billingGroupUuid) {
          this.btnConfimKeys.push({ 'key': billing.uuid, 'version': billing.version })
        }
      }
      if (this.btnConfimKeys.length === 0 && !bill) {
        this.$message.warning(this.$t('act.billing.noConfirmBill'))
        return
      }
      if (this.btnConfimKeys.length === 0) {
        const state = bill.state
        if ((state === Number(BillingConstants.BILLING_NORMAL.code) || !bill.confirmed) && !bill.billingGroupUuid) {
          this.btnConfimKeys.push({ 'key': bill.uuid, 'version': bill.version })
        } else {
          this.$message.warning(this.$t('act.billing.noConfirmBill'))
          return
        }
      }
      this.$confirm(this.$t('act.billing.batchConfirmBill', [this.btnConfimKeys.length]), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        return this.checkRuleAndConfirm(true)
      }).catch(() => {
      })
    },
    // 复核按钮
    btnRecheckClickHandle() {
      const chooseRows = this.up.gridApi.getSelectedRows()
      const billing = this.selectedBilling
      this.btnRecheckBillings = []
      if (chooseRows && chooseRows.length !== 0) {
        this.btnRecheckBillings = [...chooseRows]
      } else if (billing) {
        this.btnRecheckBillings.push(billing)
      }
      if (this.btnRecheckBillings.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBill'))
        return
      }
      this.checkRuleAndConfirm(false)
    },
    // 加载指令按钮
    async loadInstructionBtns() {
      const useHqSet = UICustomUtil.getUseHqSet(UICustomConstants.SEA_BOOKING_DOMESTIC_BILLING, this.$store.getters.currentOfficeId)
      const res = await getJobInstructions({
        pageType: UICustomConstants.SEA_BOOKING_DOMESTIC_BILLING,
        branchId: this.$store.getters.currentOfficeId,
        useHqSet,
        jobKey: this.job.uuid,
        lob: this.job.lob
      })
      /* 之前需求CARGO-54242，指令【createDomesticBills】的用法错了，以下做兼容处理
       * 一、正确用法
       * 平台指令代码：platformInstructionRuleCode=createDomesticBills
       * 指令参数type：instructionParamJson.type=domesticPay/domesticReceivable/domesticBills
       * 指令参数needTips: instructionParamJson.needTips=true/false
       * 二、之前用法（要做兼容处理，转成正确格式）
       * 1. domesticPay
       * 平台指令代码：platformInstructionRuleCode=createDomesticBills
       * 租户指令代码：instructionCode=domesticPay
       * 2. domesticReceivable
       * 平台指令代码：platformInstructionRuleCode=createDomesticBills
       * 租户指令代码：instructionCode=domesticReceivable
       * 3. domesticBills
       * 平台指令代码：platformInstructionRuleCode=createDomesticBills
       * 租户指令代码：instructionCode=domesticBills
       * 4. needTips
       * 平台指令代码：platformInstructionRuleCode=createDomesticBills
       * 租户指令代码：instructionCode=needTips
       */
      const list = []
      const needTips = res.data.findIndex(item => item.platformInstructionRuleCode === 'createDomesticBills' && !item.instructionParamJson.type && item.instructionCode === 'needTips')
      for (const item of res.data) {
        if (item.platformInstructionRuleCode === 'createDomesticBills') {
          // 有配置参数type，是正确用法，直接添加到列表
          if (item.instructionParamJson.type) {
            list.push(item)
            continue
          }
          // 没有配置参数type，是之前用法，转成正确格式
          else {
            switch (item.instructionCode) {
              case 'domesticPay':
                item.instructionParamJson.type = 'domesticPay'
                if (needTips) {
                  item.instructionParamJson.needTips = 'true'
                }
                list.push(item)
                break
              case 'domesticReceivable':
                item.instructionParamJson.type = 'domesticReceivable'
                if (needTips) {
                  item.instructionParamJson.needTips = 'true'
                }
                list.push(item)
                break
              case 'domesticBills':
                item.instructionParamJson.type = 'domesticBills'
                if (needTips) {
                  item.instructionParamJson.needTips = 'true'
                }
                list.push(item)
                break
            }
          }
        } else {
          list.push(item)
        }
      }
      this.instructioinBtns = list
    },
    // 按钮确认 不为应付则其他均默认应收
    async onInstructionClick(data) {
      if (data.platformInstructionRuleCode === 'createDomesticBills') {
        const type = data.instructionParamJson.type
        const needTips = data.instructionParamJson.needTips?.toLowerCase() === 'true'
        this.operateBillDialog.instructionCode = type
        this.operateBillDialog.needTips = needTips
        this.operateBillDialog.visible = true
      } else if (data.platformInstructionRuleCode === 'internalBillEdit') {
        const subInstructionBtns = []
        if (data.instructionParamJson.editType) {
          const arr = data.instructionParamJson.editType.split(',')
          for (const item of arr) {
            const newInstruction = lodash.cloneDeep(data)
            newInstruction.instructionParamJson.editType = item
            subInstructionBtns.push(newInstruction)
          }
        } else {
          subInstructionBtns.push(data)
        }
        this.pm.btnEditClickHandler(subInstructionBtns)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.internal-bill-info::v-deep {
  .el-dialog.main-content {
    height: unset;
  }
}
</style>>
